/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/phone'
export default icon
